<script lang="ts" setup>
import Cms from "@/components/Cms.vue";
import { Link } from "@inertiajs/vue3";
import { computed, inject } from "vue";
// import { registeredComponents } from "@root/customer-care-page-init-builder.ts"; 
import { getBuilderComponents } from "@root/builder-components.ts";
let route = inject('route');
let currentUrl = computed(()=>{
    if(typeof window == 'undefined'){
        return '';
    }
    return window.location.href?.replace(window.origin, '');
});

let searchParams = computed(()=>{
    return {
        "data.pageUrl.$eq": '/customer-service'
    }
});
</script>
<template>
    <div class="contact_us">
        <h1 class="contact_us-title headline-xl">Contact Us</h1>
        <p class="contact_us-description paragraph-feature">With a dedicated staff of over 150 employees, Rothco is always here to serve you as best we can. Please take a moment to look through our <Link :href="route('customer-service.faqs')" class="paragraph-feature">Frequently Asked Questions (FAQs)</Link> to see if your question has been answered there.</p>
        <Cms model="content-section" :url="currentUrl" driver="builder" is-section :components="getBuilderComponents()" :search-params="searchParams" />
    </div>
</template>